import React from 'react';
import { Star } from 'lucide-react';
import { Section, SectionHeading } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <figure className="glass-panel gold-frame p-6 md:p-8 rounded-sm flex flex-col h-full" data-id="element-228" data-mp="3azt57ofmmxjh">
    <div className="flex items-center mb-5" data-id="element-229" data-mp="3700pmrrtfr4m">
      <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-goldDark font-display font-bold text-base md:text-lg border border-brand-gold/40 mr-4 shrink-0" data-id="element-230" data-mp="36wmotnysvpza">
        {initials}
      </div>
      <figcaption data-id="element-231" data-mp="2s2rtlkrkhz6k">
        <div className="flex text-brand-gold mb-1" aria-label="5 de 5 estrellas" data-id="element-232" data-mp="2s39syq9j0tip">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" data-id="element-233" data-mp="v7c9be7wbjt3" data-mpi={i} />)}
        </div>
        <div className="font-medium text-brand-purpleDark" data-id="element-234" data-mp="qavanq32ln1r">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-235" data-mp="h5oqvedtac90">
          {location} {product && `— ${product}`}
        </div>
      </figcaption>
    </div>
    <blockquote className="text-brand-text/90 italic flex-grow text-sm md:text-base font-display text-[17px] leading-relaxed" data-id="element-236" data-mp="m6cj23ds0z4t">
      “{text}”
    </blockquote>
  </figure>;
export const InitialTestimonials = () => <Section className="pb-16" data-id="element-237" data-mp="c8y1u1k146bg">
    <div className="max-w-3xl mx-auto" data-id="element-238" data-mp="zwpqm4mrabtm">
      <TestimonialCard initials="MG" name="María G." location="Ciudad de México" text="Por primera vez tengo un sistema completo para planificar mis sesiones de Chi Kung con criterio clínico real. Mis pacientes sienten la diferencia desde la primera semana." data-id="element-239" data-mp="zxr38djf76dg" />
    </div>
  </Section>;
const testimonials: TestimonialProps[] = [{
  initials: 'MG',
  name: 'María G.',
  location: 'Ciudad de México',
  product: 'Terapeuta holística',
  text: 'Por primera vez tengo un sistema para planificar mis sesiones con criterio clínico real. El vademécum de series por patología cambió por completo mi forma de trabajar.'
}, {
  initials: 'JL',
  name: 'Julián L.',
  location: 'Bogotá',
  product: 'Chi Kung terapéutico',
  text: 'El Tomo I de protección del terapeuta me salvó del agotamiento crónico. Antes terminaba cada jornada exhausto. Hoy tengo protocolos reales y mi energía es completamente distinta.'
}, {
  initials: 'SM',
  name: 'Sofía M.',
  location: 'Santiago',
  product: 'Terapeuta en formación',
  text: 'Recién empezaba y el Mega Pack me dio la estructura que necesitaba desde el primer paciente. Los 52 guiones de visualización por sí solos valen todo el pack.'
}, {
  initials: 'DL',
  name: 'Diego L.',
  location: 'Lima',
  product: 'Terapeuta holístico',
  text: 'El protocolo de Chi Kung adaptado me abrió un nicho que no imaginaba. Hoy trabajo con adultos mayores y pacientes posquirúrgicos con total seguridad clínica.'
}];
export const MoreTestimonials = () => <Section className="pb-16" data-id="element-240" data-mp="qtak5sgckd5u">
    <SectionHeading eyebrow="Testimonios" className="mb-12" data-id="element-241" data-mp="qu2fd26188vl">
      Lo que dicen los terapeutas que ya lo tienen
    </SectionHeading>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-242" data-mp="37g0eh98zog4c">
      {testimonials.map(t => <TestimonialCard key={t.name} {...t} data-id="element-243" data-mp="3cf3jwusvsocu" />)}
    </div>
  </Section>;